import { FunctionComponent, useEffect, useState } from 'react';
import TextInputField from '../../Components/TextInput/TextInputField';
import { FormikProps, useFormik } from 'formik';
import Select from '../../Components/Select/Select';
import { ILocationList } from './ILocation';
import { AutocompleteOption } from '../../Components/Select/ISelectProps';
import * as Yup from 'yup';
import {
  addMaster,
  clearAddMasterState,
} from '../../Redux/Slicers/Master/AddMasterSlicer';
import { useAppDispatch, useAppSelector } from '../../Redux/Store/Hooks';
import {
  clearUpdateMasterState,
  updateMaster,
} from '../../Redux/Slicers/Master/UpdateMasterSlicer';

import { addLocation } from '../../Redux/Slicers/Location/AddLocationSlicer';
import { updateLocation } from '../../Redux/Slicers/Location/UpdateLocationSlicer';
import dayjs from 'dayjs';
import { TimeField } from '@mui/x-date-pickers/TimeField';
import UploadButtonField from '../../Components/Button/UploadButtonField';
import { Button, SvgIcon, InputLabel, Divider, Container } from '@mui/material';
import { Upload } from '@mui/icons-material';

interface MasterFormProps {
  masterForm: (data: FormikProps<any>) => void;
}

const MasterForm: FunctionComponent<any> = (props) => {
  const [garageImages, setGarageImages] = useState<(File | null)[]>([null]);
  const [squareLogo, setSquareLogo] = useState<File | string | null>(null);
  const [logo, setLogo] = useState<File | string | null>(null);
  console.log(garageImages);

  const dispatch = useAppDispatch();
  const { updateableDate } = useAppSelector((state) => state.UpdateLocation);
  const { data: projectData } = useAppSelector((state) => state.Owner);

  const masterFrom = useFormik({
    initialValues,
    validationSchema: Yup.object().shape({
      location_name: Yup.string().required("Please enter Location Name"),
      location_address: Yup.string().required("Please enter address"),
      location_landmark: Yup.string().required("Please enter landmark"),
      location_lat: Yup.number().required("Please enter Latitude"),
      location_long: Yup.number().required("Please enter Longitude"),
      registerd_user_discount: Yup.number(),
      VIP_parking: Yup.boolean(),
      currency: Yup.string(),
      status: Yup.string().required("Please select Status"),
      // membership_price: Yup.number().required("Please enter membership price"),
      // membership_description: Yup.string().required(
      //   "Please enter membership description"
      // ),
      // minimum_billing_time_unit: Yup.number().required(
      //   "Please enter Minimum billing time unit"
      // ),
      // grace_time: Yup.string().required("Please enter Grace time"),
    }),
    onSubmit: (values) => {
      const formData = new FormData();

      // Append form values to FormData
      Object.keys(values).forEach((key) => {
        if (key === "garage_images" || key === "ads_image" || key === "square_logo_url" || key === "logo_url") return;
        if (key === "working_hours") {
          formData.append(key, JSON.stringify(values[key]));
        } else {
          formData.append(key, values[key]);
        }
      });

      // Append files to FormData
      garageImages.forEach((file, index) => {
        if (file) {
          formData.append(`garage_images`, file);
        }
      });
      if (values.ads_image) {
        formData.append("ads_image", values.ads_image);
      }
      if (squareLogo instanceof File) {
        formData.append("square_logo_url", squareLogo);
      }
      if (logo instanceof File) {
        formData.append("logo_url", logo);
      }

      if (updateableDate && Object.keys(updateableDate).length !== 0) {
        console.log(updateableDate._id);
        // localStorage.removeItem('location');

        localStorage.setItem("location", updateableDate._id!);
        dispatch(updateLocation(formData));
      } else {
        console.log(formData);

        dispatch(addLocation(formData));
      }
    },
  });

  useEffect(() => {
    props.masterForm(masterFrom);

    if (updateableDate) {
      const {
        ads_type: { title, description, link, image },
        ...rest
      } = updateableDate || {};

      const transformedUpdateableDate: any = {
        ...rest,
        ads_title: title ? title : "",
        ads_description: description,
        ads_link: link,
        ads_image: image,
      };

      // Update form values with the transformed object
      Object.keys(transformedUpdateableDate).forEach((key: any) => {
        masterFrom.setFieldValue(key, transformedUpdateableDate[key]);
      });

      setGarageImages(updateableDate.garage_images || []);
      setSquareLogo(updateableDate.square_logo_url || null);
      setLogo(updateableDate.logo_url || null);
    }

    return () => {
      masterFrom.resetForm();
    };
  }, [updateableDate]);

  console.log(garageImages);

  const handleGarageImageChange =
    (index: number) => (event: React.ChangeEvent<HTMLInputElement>) => {
      if (event.target.files && event.target.files.length) {
        const newImages = [...garageImages];
        newImages[index] = event.target.files[0];
        setGarageImages(newImages);
        masterFrom.setFieldValue("garage_images", newImages);
      }
    };
  const data1 = projectData?.response?.data;
  const projects = Array.isArray(data1)
    ? data1.map((project) => ({
        label: project.first_name,
        value: project._id!,
      }))
    : [];
  const addEmptyImageUpload = () => {
    if (garageImages.length < 4) {
      setGarageImages([...garageImages, null]);
    }
  };

  const renderWorkingHoursFields = (day: any) => (
    <>
      <div style={{ display: "flex", columnGap: "10px" }}>
        <Select
          sx={{ width: "50%" }}
          id={`working_hours.${day}.open`}
          name={`working_hours.${day}.open`}
          label={`${day.charAt(0).toUpperCase() + day.slice(1)} Status`}
          value={masterFrom.values.working_hours[day].open ? "Open" : "Closed"}
          options={["Open", "Closed"]}
          onChange={(_, value) => {
            masterFrom.setFieldValue(
              `working_hours.${day}.open`,
              value === "Open"
            );
          }}
          onBlur={masterFrom.handleBlur}
          placeholder="-select-"
        />
        {masterFrom.values.working_hours[day].open && (
          <>
            <TextInputField
              sx={{ width: "25%" }}
              id={`working_hours.${day}.start`}
              name={`working_hours.${day}.start`}
              label={`${day.charAt(0).toUpperCase() + day.slice(1)} Start Time`}
              value={masterFrom.values.working_hours[day].start}
              onChange={masterFrom.handleChange}
              onBlur={masterFrom.handleBlur}
              placeholder="00:00"
            />
            <TextInputField
              sx={{ width: "25%" }}
              id={`working_hours.${day}.end`}
              name={`working_hours.${day}.end`}
              label={`${day.charAt(0).toUpperCase() + day.slice(1)} End Time`}
              value={masterFrom.values.working_hours[day].end}
              onChange={masterFrom.handleChange}
              onBlur={masterFrom.handleBlur}
              placeholder="00:00"
            />
          </>
        )}
      </div>
    </>
  );

  return (
    <form
      className="vehicle_form"
      onSubmit={masterFrom.handleSubmit}
      onReset={masterFrom.handleReset}
      autoComplete="off">
      <Select
        sx={{ width: "50%" }}
        id="owner_id"
        name="owner_id"
        label="Owner Name"
        // value={masterFrom.values.owner_id.first_name}
        disabled={
          !!(
            updateableDate && Object.keys(updateableDate).length !== 0
          ) && localStorage.getItem("role") === "owner"
        }
        value={projects?.find(
          (project) => project.value === masterFrom.values._id
        )}
        options={projects}
        onChange={(_, value) => {
          const projectValue = value as AutocompleteOption;
          masterFrom.setFieldValue("owner_id", projectValue?.value);
        }}
        onBlur={masterFrom.handleBlur}
        helperText={masterFrom.touched._id && masterFrom.errors._id}
        error={masterFrom.touched._id && Boolean(masterFrom.errors._id)}
        placeholder={
          updateableDate ? masterFrom?.values?.owner_id?.first_name : "-select-"
        }
      />
      <TextInputField
        sx={{ width: "50%" }}
        id="location_name"
        name="location_name"
        label="Location Name"
        value={masterFrom.values.location_name}
        onChange={masterFrom.handleChange}
        onBlur={masterFrom.handleBlur}
        helperText={
          masterFrom.touched.location_name && masterFrom.errors.location_name
        }
        error={
          masterFrom.touched.location_name &&
          Boolean(masterFrom.errors.location_name)
        }
      />
      <TextInputField
        sx={{ width: "50%" }}
        id="location_address"
        name="location_address"
        label="Address"
        value={masterFrom.values.location_address}
        onChange={masterFrom.handleChange}
        onBlur={masterFrom.handleBlur}
        helperText={
          masterFrom.touched.location_address &&
          masterFrom.errors.location_address
        }
        error={
          masterFrom.touched.location_address &&
          Boolean(masterFrom.errors.location_address)
        }
      />
      <TextInputField
        sx={{ width: "50%" }}
        id="location_landmark"
        name="location_landmark"
        label="Landmark"
        value={masterFrom.values.location_landmark}
        onChange={masterFrom.handleChange}
        onBlur={masterFrom.handleBlur}
        helperText={
          masterFrom.touched.location_landmark &&
          masterFrom.errors.location_landmark
        }
        error={
          masterFrom.touched.location_landmark &&
          Boolean(masterFrom.errors.location_landmark)
        }
      />
      <TextInputField
        sx={{ width: "50%" }}
        id="location_lat"
        name="location_lat"
        label="Latitude"
        value={masterFrom.values.location_lat}
        onChange={masterFrom.handleChange}
        onBlur={masterFrom.handleBlur}
        helperText={
          masterFrom.touched.location_lat && masterFrom.errors.location_lat
        }
        error={
          masterFrom.touched.location_lat &&
          Boolean(masterFrom.errors.location_lat)
        }
      />
      <TextInputField
        sx={{ width: "50%" }}
        id="location_long"
        name="location_long"
        label="Longitude"
        value={masterFrom.values.location_long}
        onChange={masterFrom.handleChange}
        onBlur={masterFrom.handleBlur}
        helperText={
          masterFrom.touched.location_long && masterFrom.errors.location_long
        }
        error={
          masterFrom.touched.location_long &&
          Boolean(masterFrom.errors.location_long)
        }
      />
      <Select
        sx={{ width: "50%" }}
        id="status"
        name="status"
        label="Status"
        value={
          masterFrom.values.status === null ||
          masterFrom.values.status === undefined
            ? null
            : masterFrom.values.status
            ? "Active"
            : "In-active"
        }
        options={["Active", "In-active"]}
        onChange={(_, value) => {
          masterFrom.setFieldValue(
            "status",
            value === null ? null : value === "Active"
          );
        }}
        onBlur={masterFrom.handleBlur}
        placeholder="-select-"
      />
      <TextInputField
        sx={{ width: "50%" }}
        id="registerd_user_discount"
        name="registerd_user_discount"
        label="Registered User Discount (%)"
        value={masterFrom.values.registerd_user_discount}
        onChange={masterFrom.handleChange}
        onBlur={masterFrom.handleBlur}
        helperText={
          masterFrom.touched.registerd_user_discount &&
          typeof masterFrom.errors.registerd_user_discount === "string"
            ? masterFrom.errors.registerd_user_discount
            : undefined
        }
        error={
          masterFrom.touched.registerd_user_discount &&
          Boolean(masterFrom.errors.registerd_user_discount)
        }
      />
      <TextInputField
        sx={{ width: "50%" }}
        id="currency"
        name="currency"
        label="Currency"
        value={masterFrom.values.currency}
        onChange={masterFrom.handleChange}
        onBlur={masterFrom.handleBlur}
        helperText={
          masterFrom.touched.currency &&
          typeof masterFrom.errors.currency === "string"
            ? masterFrom.errors.currency
            : undefined
        }
        error={
          masterFrom.touched.currency && Boolean(masterFrom.errors.currency)
        }
      />
      <Select
        sx={{ width: "50%" }}
        id="VIP_parking"
        name="VIP_parking"
        label="VIP parking"
        value={
          masterFrom.values.VIP_parking === null ||
          masterFrom.values.VIP_parking === undefined
            ? null
            : masterFrom.values.VIP_parking
            ? "Active"
            : "In-active"
        }
        options={["Active", "In-active"]}
        onChange={(_, value) => {
          masterFrom.setFieldValue(
            "VIP_parking",
            value === null ? false : value === "Active"
          );
        }}
        onBlur={masterFrom.handleBlur}
        placeholder="-select-"
      />
      {/* {garageImages.map((image, index) => (
        <UploadButtonField
          key={index}
          className="upload_field"
          name="garage_images"
          multiple
          // onChange={handleGarageImageChange}
          // onChange={(event) => {
          //   if (event.target.files?.length) {
          //     const filesArray = Array.from(event.target.files).slice(0, 4);
          //     masterFrom.setFieldValue('garage_images', filesArray);
          //   }
          // }}
          onBlur={masterFrom.handleBlur}
          fileAccept="image/jpeg,image/png,image/svg+xml,image/jpg">
          {masterFrom?.values?.garage_images?.length ? (
            masterFrom.values.garage_images.map((file, index) => (
              <img
                key={index}
                src={
                  typeof file === 'string'
                    ? `${process.env.REACT_APP_API_URL}/${file}`
                    : URL.createObjectURL(file)
                }
                alt="garage_image"
                height={168}
              />
            ))
          ) : (
            <>
              <SvgIcon
                component={Upload}
                inheritViewBox
              />
              Supported Format : (1000 x 1000 px) <br /> png, jpg, svg, jpeg
            </>
          )}
        </UploadButtonField>
      ))}{' '} */}
      <InputLabel style={{ fontSize: "small" }}>Garage images</InputLabel>
      {garageImages.map((image, index) => (
        <UploadButtonField
          key={index}
          className="upload_field"
          name={`garage_images_${index}`}
          onChange={handleGarageImageChange(index)}
          onBlur={masterFrom.handleBlur}
          fileAccept="image/jpeg,image/png,image/svg+xml,image/jpg">
          {image ? (
            typeof image === "string" ? (
              <img
                src={`${process.env.REACT_APP_API_URL}/${image}`}
                alt={`garage_image_${index}`}
                height={168}
              />
            ) : (
              <img
                src={URL.createObjectURL(image as File)}
                alt={`garage_image_${index}`}
                height={168}
              />
            )
          ) : (
            <>
              <SvgIcon
                component={Upload}
                inheritViewBox
              />
              Supported Format : (1000 x 1000 px) <br /> png, jpg, svg, jpeg
            </>
          )}
        </UploadButtonField>
      ))}

      {garageImages.length < 4 && (
        <Button
          onClick={addEmptyImageUpload}
          variant="outlined"
          disabled={garageImages.length >= 4 ? true : false}>
          Add Garage Image
        </Button>
      )}

      <Divider sx={{ width: "100%" }} />
      <TextInputField
        sx={{ width: "50%" }}
        id="hourly_rate"
        name="hourly_rate"
        label="Hourly Rate"
        value={masterFrom.values.hourly_rate ?? ""}
        onChange={masterFrom.handleChange}
        onBlur={masterFrom.handleBlur}
        helperText={
          masterFrom.touched.hourly_rate &&
          typeof masterFrom.errors.hourly_rate === "string"
            ? masterFrom.errors.hourly_rate
            : undefined
        }
        error={
          masterFrom.touched.hourly_rate &&
          Boolean(masterFrom.errors.hourly_rate)
        }
      />
      <InputLabel style={{ fontSize: "small" }}>Square Logo (1:1, for notification banner)</InputLabel>
      <UploadButtonField
        className="upload_field"
        name="square_logo_url"
        onChange={(event) => {
          if (event.target.files?.length) {
            const file = event.target.files[0];
            setSquareLogo(file);
            masterFrom.setFieldValue("square_logo_url", file);
          }
        }}
        onBlur={masterFrom.handleBlur}
        fileAccept="image/jpeg,image/png,image/svg+xml,image/jpg">
        {squareLogo ? (
          <img
            src={
              typeof squareLogo === "string"
                ? `${process.env.REACT_APP_API_URL}/${squareLogo}`
                : URL.createObjectURL(squareLogo)
            }
            alt="square_logo"
            height={168}
          />
        ) : (
          <>
            <SvgIcon component={Upload} inheritViewBox />
            Square Logo (1:1 ratio) — png, jpg, svg, jpeg
          </>
        )}
      </UploadButtonField>
      <InputLabel style={{ fontSize: "small" }}>Horizontal Logo (for in-app display)</InputLabel>
      <UploadButtonField
        className="upload_field"
        name="logo_url"
        onChange={(event) => {
          if (event.target.files?.length) {
            const file = event.target.files[0];
            setLogo(file);
            masterFrom.setFieldValue("logo_url", file);
          }
        }}
        onBlur={masterFrom.handleBlur}
        fileAccept="image/jpeg,image/png,image/svg+xml,image/jpg">
        {logo ? (
          <img
            src={
              typeof logo === "string"
                ? `${process.env.REACT_APP_API_URL}/${logo}`
                : URL.createObjectURL(logo)
            }
            alt="logo"
            height={168}
          />
        ) : (
          <>
            <SvgIcon component={Upload} inheritViewBox />
            Horizontal Logo — png, jpg, svg, jpeg
          </>
        )}
      </UploadButtonField>
      {/* {garageImages.map((_, index) => (
      <UploadButtonField
        key={index}
        className="upload_field"
        name={`garage_images_${index}`}
        onChange={handleGarageImageChange(index)}
        onBlur={masterFrom.handleBlur}
        fileAccept="image/jpeg,image/png,image/svg+xml,image/jpg">
          {masterFrom.values.garage_images?.map(_,index)}
        {garageImages[index] ? (
          <img 
            src={URL.createObjectURL(garageImages[index] as File)}
            alt={`garage_image_${index}`}
            height={168}
          />
        ) : (
          <>
            <SvgIcon
              component={Upload}
              inheritViewBox
            />
            Supported Format : (1000 x 1000 px) <br /> png, jpg, svg, jpeg
          </>
        )}
      </UploadButtonField>
    ))}

    {garageImages.length < 4 && (
      <Button
        onClick={addEmptyImageUpload}
        variant="outlined">
        Add Garage Image
      </Button>
    )} */}
      {/* <Divider sx={{ width: '100%' }} />
      <TextInputField
        sx={{ width: '50%' }}
        id="ads_title"
        name="ads_title"
        label="Title"
        value={masterFrom.values.ads_title}
        onChange={masterFrom.handleChange}
        onBlur={masterFrom.handleBlur}
        helperText={masterFrom.touched.ads_title && masterFrom.errors.ads_title}
        error={
          masterFrom.touched.ads_title && Boolean(masterFrom.errors.ads_title)
        }
      />
      <TextInputField
        sx={{ width: '50%' }}
        id="ads_description"
        name="ads_description"
        label="Ads Description"
        value={masterFrom.values.ads_description}
        onChange={masterFrom.handleChange}
        onBlur={masterFrom.handleBlur}
        helperText={
          masterFrom.touched.ads_description &&
          masterFrom.errors.ads_description
        }
        error={
          masterFrom.touched.ads_description &&
          Boolean(masterFrom.errors.ads_description)
        }
      />
      <TextInputField
        sx={{ width: '50%' }}
        id="ads_link"
        name="ads_link"
        label="Ads Link"
        value={masterFrom.values.ads_link}
        onChange={masterFrom.handleChange}
        onBlur={masterFrom.handleBlur}
        helperText={masterFrom.touched.ads_link && masterFrom.errors.ads_link}
        error={
          masterFrom.touched.ads_link && Boolean(masterFrom.errors.ads_link)
        }
      />
      <InputLabel style={{ fontSize: 'small' }}>Ad Image</InputLabel>
      <UploadButtonField
        className="upload_field"
        name="ads_image"
        onChange={(event) => {
          if (event.target.files?.length) {
            masterFrom.setFieldValue('ads_image', event.target.files[0]);
          }
        }}
        onBlur={masterFrom.handleBlur}
        fileAccept="image/jpeg,image/png,image/svg+xml,image/jpg">
        {masterFrom.values.ads_image ? (
          <img
            src={
              typeof masterFrom.values.ads_image === 'string'
                ? `${process.env.REACT_APP_API_URL}/${masterFrom.values.ads_image}`
                : URL.createObjectURL(masterFrom.values.ads_image)
            }
            alt="ads_image"
            height={168}
          />
        ) : (
          <>
            <SvgIcon
              component={Upload}
              inheritViewBox
            />
            Supported Format : (1000 x 1000 px) <br /> png, jpg, svg, jpeg
          </>
        )}
      </UploadButtonField> */}
      {/* {!updateableDate && ( */}
      <>
        <Divider sx={{ width: "100%" }} />

        {/* <InputLabel style={{ fontSize: "small" }}>
          Membership Details
        </InputLabel>

        <TextInputField
          sx={{ width: "50%" }}
          id="membership_price"
          name="membership_price"
          label="Membership price"
          value={masterFrom.values.membership_price}
          onChange={masterFrom.handleChange}
          onBlur={masterFrom.handleBlur}
          helperText={
            masterFrom.touched.membership_price &&
            typeof masterFrom.errors.membership_price === "string"
              ? masterFrom.errors.membership_price
              : undefined
          }
          error={
            masterFrom.touched.membership_price &&
            Boolean(masterFrom.errors.membership_price)
          }
        />
        <TextInputField
          sx={{ width: "100%" }}
          id="membership_description"
          name="membership_description"
          label="Membership Description"
          value={masterFrom.values.membership_description}
          onChange={masterFrom.handleChange}
          onBlur={masterFrom.handleBlur}
          helperText={
            masterFrom.touched.membership_description &&
            typeof masterFrom.errors.membership_description === "string"
              ? masterFrom.errors.membership_description
              : undefined
          }
          error={
            masterFrom.touched.membership_description &&
            Boolean(masterFrom.errors.membership_description)
          }
        /> */}

        {/* <InputLabel style={{ fontSize: "small" }}>
          Membership Details
        </InputLabel> */}

        {/* <TextInputField
          sx={{ width: "50%" }}
          id="minimum_billing_time_unit"
          name="minimum_billing_time_unit"
          label="Minimum Billing Time"
          value={masterFrom.values.minimum_billing_time_unit}
          onChange={masterFrom.handleChange}
          onBlur={masterFrom.handleBlur}
          helperText={
            masterFrom.touched.minimum_billing_time_unit &&
            typeof masterFrom.errors.minimum_billing_time_unit === "string"
              ? masterFrom.errors.minimum_billing_time_unit
              : undefined
          }
          error={
            masterFrom.touched.minimum_billing_time_unit &&
            Boolean(masterFrom.errors.minimum_billing_time_unit)
          }
        />
        <TextInputField
          sx={{ width: "50%" }}
          id="grace_time"
          name="grace_time"
          label="Grace Time"
          value={masterFrom.values.grace_time}
          onChange={masterFrom.handleChange}
          onBlur={masterFrom.handleBlur}
          helperText={
            masterFrom.touched.grace_time &&
            typeof masterFrom.errors.grace_time === "string"
              ? masterFrom.errors.grace_time
              : undefined
          }
          error={
            masterFrom.touched.grace_time &&
            Boolean(masterFrom.errors.grace_time)
          }
        /> */}
      </>
      <>
        <Divider sx={{ width: "100%" }} />
        <InputLabel>Working Time</InputLabel>
        {Object.keys(masterFrom.values.working_hours).map((day) => (
          <div
            style={{ width: "100%" }}
            key={day}>
            {renderWorkingHoursFields(day)}
          </div>
        ))}
      </>
      {/* )} */}
      <button
        type="submit"
        style={{ display: "none" }}
      />
    </form>
  );
};

export default MasterForm;

const initialValues: ILocationList = {
  location_name: "",
  location_address: "",
  location_landmark: "",
  location_lat: 0,
  location_long: 0,
  phone: "",
  status: null,
  working_hours: {
    sun: { open: false, start: "", end: "" },
    mon: { open: false, start: "", end: "" },
    tues: { open: false, start: "", end: "" },
    wed: { open: false, start: "", end: "" },
    thurs: { open: false, start: "", end: "" },
    fri: { open: false, start: "", end: "" },
    sat: { open: false, start: "", end: "" },
  },
  owner_id: {
    first_name: "",
  },
  garage_images: [],
  ads_image: undefined,
  ads_title: "",
  ads_description: "",
  ads_link: "",
  square_logo_url: null,
  logo_url: null,
  hourly_rate: "",
  currency: "",
  registerd_user_discount: "",
  VIP_parking: "",
  // membership_price: 0,
  // membership_description: "",
  minimum_billing_time_unit: "",
  grace_time: "",
};
